import React from 'react'
import { Tabs, Tab } from '../Atom/Tabs/NewTabs';
import CommentsSection from './CommentsSection';
import HistorySection from './HistorySection';

const CommentAndHistory = ({ assignmentId, taskId, exhibitorId }) => {
  return (
    <div className="h-100 px-3">
      <Tabs>
        <Tab title="COMMENTS">
          <CommentsSection taskId={taskId} exhibitorId={exhibitorId} />
        </Tab>
        <Tab title="HISTORY">
          <HistorySection assignmentId={assignmentId} />
        </Tab>
      </Tabs>
    </div>
  )
}

export default CommentAndHistory;